import React from 'react'
import classNames from 'classnames'

const InputFloatingComment = ({
    onChange,
    className,
    hidden = true,
    position = {},
    ...props
}) => {
    return (
        <div 
            className={classNames("input-floating-comment", className)} 
            hidden={hidden} 
            style={position}
        >
            <textarea
                className="input"
                type="text"
                placeholder="Add Comment"
                onChange={onChange}
                autoFocus
                {...props}
            />
        </div>
    )
}

export default InputFloatingComment